import "./App.scss";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useEffect } from "react";
import { Home } from "./components/home";
import Auth from "./components/auth/Auth";
import { Scanning } from "./components/scanning/Scanning";
import { useAppDispatch, useAppSelector } from "./redux/hooks";
import { logout } from "./components/auth/AuthSlice";
import EvaluatorDashboard from "./components/evaluator/EvaluatorDashboard";
import EvaluatorDetails from "./components/evaluator/EvaluatorDetails";
import EvaluatorReportPage from "./components/evaluator/EvaluatorReportPage";
import LandingPage from "./components/landing/LandingPage";
import CampaignPage from "./components/landing/CampaignPage";
import CoachingPage from "./components/landing/CoachingPage";
import SchoolsPage from "./components/landing/SchoolsPage";
import UniversitiesPage from "./components/landing/UniversitiesPage";
import SupportPage from "./components/landing/SupportPage";
import UseCasesPage from "./components/landing/UseCasesPage";
import ResourcesPage from "./components/landing/ResourcesPage";
import CaseStudyPage from "./components/landing/CaseStudyPage";
// import BlogPage from "./components/landing/BlogPage";
import SampleReportsPage from "./components/landing/SampleReportsPage";
import RubricTemplatesPage from "./components/landing/RubricTemplatesPage";
// import CompanyPage from "./components/landing/CompanyPage";
import AboutPage from "./components/landing/AboutPage";
// import TeamPage from "./components/landing/TeamPage";
import CareersPage from "./components/landing/CareersPage";
// import PressPage from "./components/landing/PressPage";
import TrustPage from "./components/landing/TrustPage";

function AppContent() {
  const dispatch = useAppDispatch();
  const { isAuthenticated } = useAppSelector((state) => state.auth);

  // Sync auth state across browser tabs
  useEffect(() => {
    const handleStorageChange = (event: StorageEvent) => {
      // Check if persist:root was removed or modified
      if (event.key === 'persist:root') {
        if (!event.newValue) {
          // localStorage was cleared - user logged out in another tab
          dispatch(logout());
          window.location.href = '/';
        } else {
          // Check if authenticated changed
          try {
            const newState = JSON.parse(event.newValue);
            const auth = JSON.parse(newState.auth || '{}');

            // If current tab thinks it's auth but storage says not auth -> logout
            if (isAuthenticated && !auth.isAuthenticated) {
              dispatch(logout());
              window.location.href = '/';
            }
            // If current tab thinks it's NOT auth but storage says auth -> reload to login
            else if (!isAuthenticated && auth.isAuthenticated) {
              window.location.reload();
            }
          } catch {
            // JSON parse error - ignore
          }
        }
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, [dispatch, isAuthenticated]);

  return (
    <Routes>
      {/* Public Landing Page - always accessible */}
      <Route
        path="/"
        element={<LandingPage />}
      />
      <Route
        path="/campaign"
        element={<CampaignPage />}
      />
      <Route
        path="/coaching"
        element={<CoachingPage />}
      />
      <Route
        path="/schools"
        element={<SchoolsPage />}
      />
      <Route
        path="/universities"
        element={<UniversitiesPage />}
      />
      <Route
        path="/support"
        element={<SupportPage />}
      />
      <Route
        path="/use-cases/*"
        element={<UseCasesPage />}
      />
      <Route
        path="/resources"
        element={<ResourcesPage />}
      />
      <Route
        path="/resources/case-study"
        element={<CaseStudyPage />}
      />
      {/* <Route
        path="/resources/blog"
        element={<BlogPage />}
      /> */}
      <Route
        path="/resources/sample-reports"
        element={<SampleReportsPage />}
      />
      <Route
        path="/resources/rubric-templates"
        element={<RubricTemplatesPage />}
      />
      {/* <Route
        path="/company"
        element={<CompanyPage />}
      /> */}
      <Route
        path="/company/about"
        element={<AboutPage />}
      />
      {/* <Route
        path="/company/team"
        element={<TeamPage />}
      /> */}
      <Route
        path="/company/careers"
        element={<CareersPage />}
      />
      {/* <Route
        path="/company/press"
        element={<PressPage />}
      /> */}
      <Route
        path="/company/trust"
        element={<TrustPage />}
      />
      <Route
        path="/login"
        element={isAuthenticated ? <Navigate to="/home" replace /> : <Auth />}
      />
      <Route
        path="/home"
        element={isAuthenticated ? <Home /> : <Navigate to="/login" replace />}
      />
      <Route
        path="/scan"
        element={isAuthenticated ? <Scanning /> : <Navigate to="/login" replace />}
      />
      <Route
        path="/evaluator"
        element={isAuthenticated ? <EvaluatorDashboard /> : <Navigate to="/login" replace />}
      />
      <Route
        path="/evaluator/:paperId"
        element={isAuthenticated ? <EvaluatorDetails /> : <Navigate to="/login" replace />}
      />
      <Route
        path="/evaluator/:paperId/report/:sheetId"
        element={isAuthenticated ? <EvaluatorReportPage /> : <Navigate to="/login" replace />}
      />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
